import { Inject, Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class FlashMessageService {
  public flashMessage: Subject<{
    message: string
    className: string
  }> = new Subject()

  timeout: number = 6000

  success(message: string, sticky = false): void {
    this.flashMessage.next({
      message,
      className: 'notification is-success-light'
    })
    setTimeout(
      () => {
        this.flashMessage.next(null)
      },
      sticky ? 9999999 : this.timeout
    )
  }

  error(message: string, sticky = false): void {
    this.flashMessage.next({
      message,
      className: 'notification is-danger is-light'
    })
    setTimeout(
      () => {
        this.flashMessage.next(null)
      },
      sticky ? 9999999 : this.timeout
    )
  }

  info(message: string, sticky = false): void {
    this.flashMessage.next({
      message,
      className: 'notification is-info is-light'
    })
    setTimeout(
      () => {
        this.flashMessage.next(null)
      },
      sticky ? 9999999 : this.timeout
    )
  }
}
